  <form [formGroup]="myTaskForm">  
  <div class="createTask"> 
    <div class="block colorExternal">
      <div class="selectTaskColor">
        <div class="selectedColor" (click)="toggleColorSelection()">
          <span [ngStyle]="{ 'background-color': selectedColor }"></span>
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
        <div class="colGroup" *ngIf="showColorPannel">
          <ng-container *ngFor="let color of colors; let i; as: index">
            <label class="colm" [ngStyle]="{ 'background-color': color.colname }">
              <input  type="radio" id="{{ i }}" type="radio" value="{{ color.colname }}"
               (click)="SelectColor(color.colname)" name="noteColor"/>
              <span class="checkmark"></span>
            </label>
          </ng-container>
        </div>
      </div>
      <div class="extrnalTask">
        <!-- <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox> -->
        <mat-checkbox color="primary" formControlName="isInternal">External Task</mat-checkbox>
        <mat-checkbox class="ml-5" color="primary" formControlName="isDueDateTrigger">Due Date Trigger</mat-checkbox>
      </div>
    </div>
    <div class="block">
      <mat-form-field class="taskTitle">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" maxlength="100" placeholder="Task Name"/>
      </mat-form-field>
    </div>

    <div class="block block_division">
      <mat-form-field class="dateInput">
        <mat-label>Start date</mat-label>
          <input matInput [matDatepicker]="picker1" formControlName="startDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>      
      </mat-form-field>
      
      <mat-form-field class="dateInput">      
        <mat-label>Due date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="dueDate" readonly>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>      
       
      </mat-form-field>
    </div>
    <div class="block">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" maxlength="500"
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="2">
        </textarea>
      </mat-form-field>
    </div>

    <div class="actionBtnHolder">
      <button mat-flat-button class="cancel" (click)="close()">
        Close
      </button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary"
      [disabled]="myTaskForm.invalid || !myTaskForm.dirty" type="submit"
      (click)="SaveTaskDetails(myTaskForm.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </div>
  </div> 
</form>













